export const NETWORK_GRID_EXPORT_FIELDS = [
  {
    label: "Value",
    value: "requested_network_location"
  },
  {
    label: "Type",
    value: "type"
  },
  {
    label: "Classification",
    value: "classification"
  },
  {
    label: "Threat Level",
    value: "threat_level"
  },
  {
    label: "First Seen",
    value: "first_seen"
  },
  {
    label: "Last Seen",
    value: "last_seen"
  },
  {
    label: "Username",
    value: "string_submission_user_latest"
  },
  {
    label: "Classification Reason",
    value: "reason"
  },
  {
    label: "Reputation",
    value: "third_party_reputations"
  },
  {
    label: "Category",
    value: "categories"
  }
];
